import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {PropertyFormComponent} from "../property-form/property-form.component";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {PropertyService} from '../services/property.service';
import {FormModel, FormTypes} from '../models/constants';
import {CommonModule, NgIf} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {MultiSelectModule} from 'primeng/multiselect';
import {CheckboxModule} from 'primeng/checkbox';
import {RadioButtonModule} from 'primeng/radiobutton';
import {QuestionButtonComponent} from '../../question-button/question-button.component';
import {InputTextModule} from 'primeng/inputtext';
import {CalendarModule} from "primeng/calendar";


@Component({
    selector: 'app-form-element',
    templateUrl: './form-element.component.html',
    styleUrls: ['./form-element.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgIf,
        DropdownModule,
        TranslatePipe,
        MultiSelectModule,
        CheckboxModule,
        RadioButtonModule,
        QuestionButtonComponent,
        InputTextModule,
        CalendarModule
    ],
    providers: [DialogService, PropertyService]
})
export class FormElementComponent implements OnInit {

    readonly FormTypes = FormTypes;

    @Input() type!: FormTypes;
    @Input() formGroup!: FormGroup;
    @Input() formControl: FormControl | undefined; // only Checkboxes
    @Input() formName: string | undefined;
    @Input() formLabel!: string;
    @Input() formId!: string;
    @Input() formValue: string | boolean | undefined;
    @Input() formValues: FormModel[] | undefined;
    @Input() noLabel: boolean | undefined;
    @Input() noListEdit: boolean | undefined;
    @Input() css: string | undefined;
    @Input() questionEdit!: boolean;
    @Input() questionVisibility!: boolean;
    @Input() hideFloatingLabel: boolean | undefined;
    @Input() filterShow!: boolean;
    @Input() filterBy!: string;
    @Input() calendarLeft: boolean | undefined;
    @Input() dateFormat: string | undefined;
    isFormIdMessage!: boolean;

    ref!: DynamicDialogRef;


    constructor(public dialogService: DialogService,
                public translate: TranslateService,
                private propertyService: PropertyService) {

        if (this.formLabel === undefined) {
            this.formLabel = "";
        }

    }

    ngOnInit(): void {

        if (this.formId === 'message') {
            this.isFormIdMessage = true;
        }

        document.documentElement.style.setProperty('--editList', this.noListEdit ? 'false' : 'true');


        if (!this.formName) {
            this.formName = this.formId;
        }
        if (!this.formLabel) {
            this.formLabel = '' + this.formId;
        }
        //const con = this.formGroup.controls['id'].value;
    }


    showPropertyForm() {


        this.ref = this.dialogService.open(PropertyFormComponent, {
            header: "",
            width: '70%',
            data: {
                propertyKey: this.formId,
                propertyLabel: this.translate.instant(this.formLabel),
            },

        });
        this.ref.onClose.subscribe(value => {
            if (value) {
                this.propertyService.getPropertyListByKey(this.formId).then(data => this.formValues = data);
            }
        });
    }
}
